import moment from 'moment';
/**
 * @param {HTMLElement|undefined} optionalContainer
 */
export default function init(optionalContainer) {
	$('.js-date', optionalContainer).each(function() {
		const $this = $(this);
		const dateText = $this.data('date') ? $this.data('date') : $this.text();
		const date = moment(dateText);
		const format = $this.data('format');

		if ( date.isValid() ) {
			$this.html(date.format(format));
		} else {
			$this.remove();
		}
	});
}